"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TealiumEventAction = exports.TealiumComponent = exports.TealiumElement = exports.TealiumFormat = exports.TealiumAction = exports.PARTNERSHIP_INTERSTITIAL_CONTINUE_BUTTON = exports.PARTNERSHIP_INTERSTITIAL_DISMISS_LINK = exports.PARTNERSHIP_INTERSTITIAL_CROSS_ICON = exports.PARTNERSHIP_INTERSTITIAL_OPEN_MODAL = void 0;
exports.PARTNERSHIP_INTERSTITIAL_OPEN_MODAL = 'PARTNERSHIP_INTERSTITIAL_OPEN_MODAL';
exports.PARTNERSHIP_INTERSTITIAL_CROSS_ICON = 'PARTNERSHIP_INTERSTITIAL_CROSS_ICON';
exports.PARTNERSHIP_INTERSTITIAL_DISMISS_LINK = 'PARTNERSHIP_INTERSTITIAL_DISMISS_LINK';
exports.PARTNERSHIP_INTERSTITIAL_CONTINUE_BUTTON = 'PARTNERSHIP_INTERSTITIAL_CONTINUE_BUTTON';
var TealiumAction;
(function (TealiumAction) {
    TealiumAction["CLICK"] = "click";
    TealiumAction["CLOSE"] = "close";
    TealiumAction["CONTINUE"] = "continue";
    TealiumAction["OPEN"] = "open";
})(TealiumAction || (exports.TealiumAction = TealiumAction = {}));
var TealiumFormat;
(function (TealiumFormat) {
    TealiumFormat["MODAL"] = "modal";
    TealiumFormat["BUTTON"] = "button";
    TealiumFormat["LINK"] = "link";
    TealiumFormat["CROSS"] = "cross";
})(TealiumFormat || (exports.TealiumFormat = TealiumFormat = {}));
var TealiumElement;
(function (TealiumElement) {
    TealiumElement["CONTINUE"] = "continue";
    TealiumElement["CROSS"] = "cross";
    TealiumElement["DISMISS"] = "dismiss";
    TealiumElement["FULL"] = "full";
})(TealiumElement || (exports.TealiumElement = TealiumElement = {}));
var TealiumComponent;
(function (TealiumComponent) {
    TealiumComponent["PARTNERSHIP_MODAL"] = "modal/partnershipSavingsAccount";
})(TealiumComponent || (exports.TealiumComponent = TealiumComponent = {}));
var TealiumEventAction;
(function (TealiumEventAction) {
    TealiumEventAction["SAVING_ACCOUNT_MODAL"] = "partnershipSavingsAccount";
})(TealiumEventAction || (exports.TealiumEventAction = TealiumEventAction = {}));
//# sourceMappingURL=action.constants.js.map